export default __webpack_public_path__ + "static/media/img-0719-estonia-full-face.aa58505c.png";